module.exports = __webpack_public_path__ + "img/list20231114005.ec258b90.png";